__turbopack_context__.v({
  "quoteActionsContainer": "CEHWKG_quoteActionsContainer",
});
